import { logger } from "@/shared/logger/logger";
import { Button, Container, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";

export function RootErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  logger.error("route_error_boundary", {
    error: error instanceof Error ? { name: error.name, message: error.message } : error,
  });

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : t("states.error");

  return (
    <Container size="sm" py="xl">
      <Stack gap="md" align="center">
        <Title order={2}>{t("states.error")}</Title>
        <Text c="dimmed">{message}</Text>
        <Button onClick={() => navigate("/")} variant="light">
          {t("actions.back")}
        </Button>
      </Stack>
    </Container>
  );
}
